import type { RouteObject } from 'react-router'
import { createStripeCallbackLoader } from '@/features/billing/stripe-connect/stripe-connect-route-loaders'

/**
 * Creates routes for the billing feature.
 */
export function createRoutes(): RouteObject[] {
  return [
    {
      path: '/callback/stripe-connect',
      loader: createStripeCallbackLoader(),
      lazy: {
        Component: () =>
          import('@/features/billing/stripe-connect/StripeCallback/StripeCallbackContainer').then(
            (r) => r.default,
          ),
      },
    },
  ]
}
